module.exports = __webpack_public_path__ + "img/2.ec659b4a.jpg";